<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
		<div class="-two-columns">

            <div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>


            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Clients</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @set-search-text="setSearchText('searchContactText', $event)"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :showDeleted="showDeleted"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h1 class="o-form__title">Clients</h1> -->
                            <input v-if="form.id" type="hidden" v-model="form.id" />
                            <div class="o-form__item full-width q-mb-lg">
                                <Input
                                    v-model="form.name"
                                    ref="name"
                                    placeholder="Nom du client"
                                    label="Nom du client"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.primary_phone"
                                    placeholder="(111) 111-1111"
                                    label="Téléphone principal"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.secondary_phone"
                                    placeholder="(111) 111-1111"
                                    label="Téléphone secondaire"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item q-mb-lg">
                                <Input
                                    v-model="form.fax"
                                    placeholder="(111) 111-1111"
                                    label="Télécopieur"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                            </div>
                            <div class="o-form__item q-mb-lg">
                                <Input
                                    v-model="form.email"
                                    placeholder="courriel@exemple.com"
                                    label="Courriel"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item q-mb-lg">
                                <Input
                                    v-model="form.website"
                                    placeholder="https://lesite.com"
                                    label="Site Internet"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.street"
                                    placeholder="Rue"
                                    label="Adresse"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.town"
                                    placeholder="Ville"
                                    label="Ville"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.state"
                                    placeholder="Ex. Qc"
                                    label="Province"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.country"
                                    placeholder="Pays"
                                    label="Pays"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.zipcode"
                                    placeholder="Ex. A1A 1A1"
                                    label="Code postal"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <q-item tag="label">

                                        <q-checkbox size="xs" dense v-model="form.use_contact_as_location" class="q-mr-sm" />
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Utiliser l'adresse du client comme lieu de
                                            rassemblement</q-item-label>

                                </q-item>
                            </div>
                            <!-- <div class="o-form__item q-mb-lg">
                            </div> -->
                            <div class="o-form__item">
                                <Input
                                    type="textarea"
                                    v-model="form.note"
                                    placeholder="Note"
                                    label="Note"
                                    autogrow
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    type="textarea"
                                    v-model="form.internal_notes"
                                    placeholder="Note interne"
                                    label="Note interne"
                                    autogrow
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                                <q-item-label caption class="q-mt-sm">
                                    Les notes internes ne sont pas visibles que par un administrateur.
                                </q-item-label>

                            </div>
                            <!-- <div class="o-form__item -button -multiple">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->


                            <div v-if="form.id" class="full-width">
                                <CustomersContacts
                                    v-bind:parent_id="form.id"
                                    :embedded="true"
                                    class="q-mt-md q-mb-lg"
                                />
                                <CustomersLocations
                                    class="q-mt-md"
                                    v-bind:parent_id="form.id"
                                    :embedded="true"
                                />
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { CUSTOMERS, CUSTOMERSSEARCH/*, CONTACTS, LOCATIONS*/ } from '@/graphql/customer/queries'
    import { UPSERTCUSTOMER, DELETECUSTOMER, RESTORECUSTOMER } from '@/graphql/customer/mutations'
    import { removeNULL } from '@/js/utilities'
    import CustomersContacts from '@/components/settings/CustomersContacts'
    import CustomersLocations from '@/components/settings/CustomersLocations'

    export default {
        name: 'Customers',
        components: {
            CustomersContacts,
            CustomersLocations,
        },
        apollo: {
            customers: {
                query: CUSTOMERS,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        trashed: this.trashed,
                        first: this.perPage,
                    }
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(customers) {
                    this.listbox.listItems = Object.assign([], customers.customers.data)
                    return customers;
                },
                // variables() {
                //     return {
                //         searchText: this.searchContactText
                //     }
                // }
            },
        },
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchableQL: 'Rechercher / filtrer'
                },
                searchContactText: null,
                form: {},
                newItem: {
                    id: 0,
                    name: null,
                    primary_phone: null,
                    secondary_phone: null,
                    fax: null,
                    street: null,
                    town: null,
                    state: null,
                    country: null,
                    zipcode: null,
                    website: null,
                    email: null,
                },
                showDeleted: false,
                perPage: 50,
            }
        },
        mounted: async function(){
            this.setNewItem();
        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form=Object.assign({}, item);
            },
            setNewItem(){
                this.setSelected(this.newItem);
                this.setFocus('name')

                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })

            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            setFocus(/*ref*/){
                // if(this.$refs[ref]) this.$refs[ref].$el.getElementsByTagName('input')[0].focus();
            },
            setSearchText(prop, searchText){
                this.setSelected(this.newItem);
                if(searchText && searchText.length>1) searchText=searchText.trim().split(" ").join("* ")+"*";
                this.fetchSearchText(searchText);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETECUSTOMER,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.customers) this.$apollo.queries.customers.refetch()
                        this.setSelected(null);
                    }
                })
                this.setNewItem();
            },
            async fetchSearchText(searchText){
                if(searchText && searchText!=""){
                    if(this.$apollo.queries.customersSearch){
                        this.$apollo.queries.customersSearch.options.variables.searchText=searchText;
                        this.$apollo.queries.customersSearch.refresh();
                    } else {

                        let search = searchText.trim().split(" ").join("* ") + "*";
                        search = search.replace(/\*\*/g, '*');

                        this.$apollo.addSmartQuery('customersSearch', {
                            query: CUSTOMERSSEARCH,
                            fetchPolicy: 'network-only',
                            error(error){
                                if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                            },
                            variables: {
                                searchText: search,
                            },
                            update(customersSearch) {
                                this.listbox.listItems = Object.assign([], customersSearch.customersSearch.data)
                                return customersSearch;
                            },

                        })
                    }
                }else{
                    this.$apollo.queries.customers.refresh()
                }
            },
            saveItem(form) {
                form=removeNULL(form);
                this.$apollo.mutate({
                    mutation: UPSERTCUSTOMER,
                    variables: { ...form },
                    update: (store, { data: { upsertCustomer } }) => {
                        if (!form.id) {
                            let myVariables = { trashed: this.trashed, first: this.perPage }
                            const data = store.readQuery({ query: CUSTOMERS, variables: myVariables })
                            data.customers.data.push(upsertCustomer);
                            store.writeQuery({
                                query: CUSTOMERS,
                                data,
                            })
                        }
                        this.setSelected(upsertCustomer);
                    }
                }).then((/*data*/) => {
                    this.$q.notify({type: 'positive', message: "Client : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORECUSTOMER,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { customer } }) => {
                        if (!form.id) {
                            const data = store.readQuery({ query: CUSTOMERS })
                            data.customers.data.push(customer);
                            store.writeQuery({
                                query: CUSTOMERS,
                                data,
                            })
                        }
                        this.setSelected(customer)
                    }
                }).then(() => {
                    this.$q.notify({ type: 'positive', message: "Ressource : " + form.name, caption: "Informations sauvegardées" })
                }).catch(e => {
                    if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                }).finally(() => {
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
